import { useMemo } from 'react';
import { gainToDb } from '../utils/misc.js';
import { Icon } from './Icon.js';

interface MeterProps {
  peak: number;
  rms: number;
  clipping?: boolean;
  label?: string;
  compact?: boolean;
}

export function Meter({ peak, rms, clipping = false, label = 'MIC', compact = false }: MeterProps) {
  const rmsDb = useMemo(() => gainToDb(rms), [rms]);
  const peakDb = useMemo(() => gainToDb(peak), [peak]);
  const pct = Math.max(0, Math.min(100, ((rmsDb + 60) / 60) * 100));
  const peakPct = Math.max(0, Math.min(100, ((peakDb + 60) / 60) * 100));
  const kind = clipping || peak >= .995 ? 'clip' : rmsDb > -9 ? 'hot' : rmsDb < -42 ? 'quiet' : 'good';

  return (
    <div className={`meter ${compact ? 'meter-compact' : ''}`} aria-label={`${label}: pico ${peakDb.toFixed(0)} dBFS`}>
      <div className="meter-head">
        <span className="meter-name">{label}</span>
        <span className={`meter-badge meter-${kind}`}>
          {clipping || peak >= .995 ? <><Icon name="alert" size={12} /> CLIP</> : `${Math.round(rmsDb)} dB`}
        </span>
      </div>
      <div className="meter-track" aria-hidden="true">
        <div className={`meter-fill meter-fill-${kind}`} style={{ width: `${pct}%` }} />
        <div className="meter-peak" style={{ left: `${peakPct}%` }} />
        <i className="meter-mark" style={{ left: '30%' }} />
        <i className="meter-mark" style={{ left: '55%' }} />
        <i className="meter-mark meter-mark-hot" style={{ left: '82%' }} />
      </div>
      {!compact && <div className="meter-scale"><span>−60</span><span>−42</span><span>−27</span><span>−12</span><span>0 dBFS</span></div>}
    </div>
  );
}
